/* eslint-disable prettier/prettier */
import moment from "moment";
import store from "@/store";
import {
  ODataString,
  ODataDecimal,
  ODataDate,
  ODataBoolean,
  ODataDateTime,
  ODataInteger,
  ODataCustom,
  ODataStringContains,
  // ODataStringEndsWith,
  ODataStringNotContains,
  // ODataStringStartsWith,
  // ODataStringEquals,
  // ODataStringNotEquals,
} from "pbas-vue-components";
import { translate } from "../trans";
import { translate2 } from "../trans2";
import { ODataHeader } from "pbas-vue-components";
import { i18n } from "./i18n";

const helperMethods = {
  months: () => [
    {
      text: i18n.t("globals.January"),
      value: 1,
    },
    {
      text: i18n.t("globals.February"),
      value: 2,
    },
    {
      text: i18n.t("globals.March"),
      value: 3,
    },
    {
      text: i18n.t("globals.April"),
      value: 4,
    },
    {
      text: i18n.t("globals.May"),
      value: 5,
    },
    {
      text: i18n.t("globals.June"),
      value: 6,
    },
    {
      text: i18n.t("globals.July"),
      value: 7,
    },
    {
      text: i18n.t("globals.August"),
      value: 8,
    },
    {
      text: i18n.t("globals.September"),
      value: 9,
    },
    {
      text: i18n.t("globals.October"),
      value: 10,
    },
    {
      text: i18n.t("globals.November"),
      value: 11,
    },
    {
      text: i18n.t("globals.December"),
      value: 12,
    },
  ],
  formattedDateNow: () => {
    let day = new Date().toLocaleDateString("en-us", { day: "numeric" });
    let month = new Date().toLocaleDateString("en-us", { month: "numeric" });
    let year = new Date().toLocaleDateString("en-us", { year: "numeric" });
    const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
      2,
      "0",
    )}`;
    return formattedDate;
  },
  dateNow: () => {
    return moment().toISOString();
  },
  dateRangesMonths: (months) => {
    const utcOffset = moment().utcOffset();
    if (months <= 0) return;
    if (months >= 1) {
      const startDate = moment()
        .subtract(utcOffset, "minutes")
        .subtract(months, "months");
      return [
        startDate.format("YYYY-MM-DD"),
        moment().subtract(utcOffset, "minutes").format("YYYY-MM-DD"),
      ];
    }
    if (months === 0.5) {
      const startDate = moment()
        .subtract(utcOffset, "minutes")
        .subtract(14, "days");
      return [
        startDate.format("YYYY-MM-DD"),
        moment().subtract(utcOffset, "minutes").format("YYYY-MM-DD"),
      ];
    }
  },
  datesLastMonthsOnly: () => {
    const utcOffset = moment().utcOffset();
    const startDate = moment()
      .subtract(utcOffset, "minutes")
      .subtract(1, "month")
      .startOf("month");
    const endDate = moment()
      .subtract(utcOffset, "minutes")
      .subtract(1, "month")
      .endOf("month");
    return [startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD")];
  },
  dateRangesForYear: (year) => {
    const startDateOfTheYear = moment([year]);
    // console.log(
    //   "start day of year",
    //   startDateOfTheYear.format("YYYY-MM-DD"),
    //   moment([year]).endOf("year").format("YYYY-MM-DD"),
    //   year
    // );
    if (year === moment().year()) {
      return [
        startDateOfTheYear.format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ];
    } else {
      return [
        startDateOfTheYear.format("YYYY-MM-DD"),
        moment([year]).endOf("year").format("YYYY-MM-DD"),
      ];
    }
  },
  thisYear: (yearToAdd) => {
    const utcOffset = moment().utcOffset();
    const year = moment()
      .subtract(utcOffset, "minutes")
      .add(yearToAdd, "years")
      .year();
    return year;
  },
  formatDateForPrint(date) {
    if (date)
      // return moment(date, ["YYYY/MM/DD", "YYYY-MM-DD"]).format("MMM-DD-YYYY");
      return moment(date).format("MMM-DD-YYYY");
    else return "";
  },
  formatDate(dateString) {
    // console.log(dateString);
    if (dateString === undefined || dateString === null) {
      return "";
    }
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  },
  formatDateTime(date) {
    if (date)
      // return moment(date, ["YYYY/MM/DD", "YYYY-MM-DD"]).format("MMM-DD-YYYY");
      return moment(date).format("MMM-DD-YYYY, h:mm:ss a");
    else return "";
  },
  numberWithCommas(x) {
    return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  fileExtension(name) {
    if (!name) return;
    const arr = name.split(".");
    if (arr.length) {
      const ext = arr[arr.length - 1];
      return ext.length > 0 ? ext : "";
    }
    return "";
  },
  toCurrency(number) {
    let ret = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);
    if (ret === "-$0.00") {
      ret = "$0.00";
    }
    return ret;
  },
  formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return match[1] + "-" + match[2] + "-" + match[3];
    }
    return null;
  },
  capitalize(str) {
    if (!str) return;
    const arr = str.split(" ");
    const capitalized = arr.map(
      (word) =>
        word.substring(0, 1).toUpperCase() +
        word.substring(1, word.length).toLowerCase(),
    );
    return capitalized.join(" ");
  },
  toISOStringLocal(d) {
    function z(n) {
      return (n < 10 ? "0" : "") + n;
    }
    return (
      d.getFullYear() +
      "-" +
      z(d.getMonth() + 1) +
      "-" +
      z(d.getDate()) +
      "T" +
      z(d.getHours()) +
      ":" +
      z(d.getMinutes()) +
      ":" +
      z(d.getSeconds())
    );
  },
  formatDrawbridgeAddress(address) {
    console.log("da: ", address);
    var res = "";
    if (address) {
      if (address.SuiteNumber) res += address.SuiteNumber;
      if (address.StreetNumber) {
        if (res.length > 0) res += " ";
        res += address.StreetNumber.toString();
      }
      if (address.StreetName) {
        if (res.length > 0) res += ", ";
        res += address.StreetName;
      }
      if (address.City) {
        if (res.length > 0) res += "\n";
        res += address.City;
      }
      if (address.Province) {
        if (res.length > 0) res += ", ";
        if (address.Province.Code) {
          res += address.Province.Code;
        } else {
          res += this.formatDrawbridgeProvinceCode(
            address.Province,
            "Province",
          );
        }
      }

      if (address.PostalCode) res += " " + address.PostalCode;
      if (address.Country)
        res += "\n " + this.formatEnumModel(address.Country, "Country");
    }
    return res;
  },
  translate(item, language) {
    if (!item) return "";
    //console.log(item, item.Translations)
    if (item.Translations) {
      let trans = item.Translations.filter((o) => o.LanguageCode === language);
      //console.log(trans)
      return trans.length > 0
        ? trans[0].DisplayValue
        : language + "-" + item.Name;
    }
    return item.Name;
  },
  translate2(item, field, language) {
    // console.log(item, field, language)
    if (item === null || item === undefined) return "";
    if (item.Translations === null || item.Translations === undefined)
      return item[field] || "";
    const trans = item.Translations.filter((o) => o.LanguageCode === language);
    if (trans.length > 0)
      if (Object.keys(trans[0]).indexOf(field) > -1)
        return trans[0][field] || item[field] || "";
    return item[field] || "";
  },
  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
  formatEnumModel(item, field, lang) {
    const enumModels = store.getters["common/enumModels"];
    const enumValue = enumModels[field].filter(
      (o) => o.value.toUpperCase() === item.toUpperCase(),
    );
    if (enumValue[0]) {
      if (lang === "en") {
        return enumValue[0].textEn;
      }
      return enumValue[0].textFr;
    }
    return "";
  },
  formatDrawbridgeProvinceCode(item, field) {
    const enumModels = store.getters["common/enumModels"];
    const enumValue = enumModels[field].filter(
      (o) => o.value.toUpperCase() === item.toUpperCase(),
    );
    if (enumValue[0]) {
      return enumValue[0].code;
    }
    return "";
  },
  createContactInfoQuery(headers) {
    const select = ["IdentityId"];
    const expand = [];
    expand.push(
      "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))",
    );
    if (
      headers.filter(
        (o) =>
          o.text === "Country" && (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      expand.push(
        "Address($select=ContactInformationId,SuiteNumber,StreetNumber,StreetName,OtherProvince,PostalCode,OtherPostalCode,City,OtherCountry;$expand=Country($select=Id,IsOther,Name;$expand=Translations($select=LanguageCode,DisplayValue)),Province($select=Id,Code,Name;$expand=Translations($select=LanguageCode,DisplayValue)))",
      );
    }
    if (
      headers.filter(
        (o) =>
          o.text === "Phone Number" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("PhoneNumber");
    }
    if (
      headers.filter(
        (o) =>
          o.text === "CommunicationPreference" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      expand.push(
        "CommunicationPreference($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))",
      );
    }
    if (
      headers.filter(
        (o) =>
          o.text === "LanguageChoice" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      expand.push(
        "LanguageChoice($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))",
      );
    }
    // if (
    //   !this.planIdentity.HasDrupalPortal ||
    //   this.planIdentity.MembersPortal === undefined ||
    //   this.planIdentity.MembersPortal === null ||
    //   !this.planIdentity.MembersPortal.IsActive
    // ) {
    //   if (
    //     headers.filter(
    //       (o) =>
    //         o.text === "Email" && (o.onEdit === "View" || o.onEdit === "Edit")
    //     ).length > 0
    //   ) {
    //     expand.push("Identity($select=Email)");
    //   }
    // }
    if (
      headers.filter(
        (o) =>
          o.text === "Home Email" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("HomeEmail");
    }
    if (
      headers.filter(
        (o) =>
          o.text === "Work Email" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("WorkEmail");
    }

    const clauses = [];

    if (select.length > 0) {
      clauses.push(`$select=${select.join(",")}`);
    }
    if (expand.length > 0) {
      clauses.push(`$expand=${expand.join(",")}`);
    }
    return "?" + clauses.join("&");
  },

  createDirectDepositQuery(headers) {
    const select = ["IdentityId"];
    const expand = [];
    expand.push(
      "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))",
    );
    if (
      headers.filter(
        (o) =>
          o.text === "Account Number" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("AccountNumber");
    }
    if (
      headers.filter(
        (o) =>
          o.text === "Transit Number" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("TransitNumber");
    }
    if (
      headers.filter(
        (o) =>
          o.text === "Institution Number" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("InstitutionNumber");
    }
    // if (
    //   headers.filter(
    //     (o) =>
    //       o.text === "Account Type" &&
    //       (o.onEdit === "View" || o.onEdit === "Edit")
    //   ).length > 0
    // ) {
    //   expand.push(
    //     "AccountType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
    //   );
    // }
    if (
      headers.filter(
        (o) =>
          o.text === "Verify Direct Deposit" &&
          (o.onEdit === "View" || o.onEdit === "Edit"),
      ).length > 0
    ) {
      select.push("VerifyDirectDeposit");
    }

    const clauses = [];

    if (select.length > 0) {
      clauses.push(`$select=${select.join(",")}`);
    }
    if (expand.length > 0) {
      clauses.push(`$expand=${expand.join(",")}`);
    }
    return "?" + clauses.join("&");
  },

  formatCurrency(v) {
    let a = parseFloat(v);
    if (isNaN(a)) return "";
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
    return formatter.format(v);
  },
  toPascalCase(w) {
    return w[0].toUpperCase() + w.slice(1).toLowerCase();
  },
  correctCase(lang, dataObject) {
    if (Object.keys(dataObject).indexOf("EN") > -1) {
      return lang.toUpperCase();
    }
    return this.toPascalCase(lang);
  },

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },

  isDate(val) {
    if (
      new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(val)
    ) {
      return !isNaN(Date.parse(val));
    }
    return false;
  },

  formatValidationDate(d) {
    let month = (d.getUTCMonth() + 1).toString();
    if (month.length === 1) {
      month = "0" + month;
    }
    let day = d.getUTCDate().toString();
    if (day.length === 1) {
      day = "0" + day;
    }
    return `${d.getUTCFullYear()}-${month}-${day}`;
  },

  notEmptyObject(o) {
    console.log(o, Object.keys(o), Object.values(o));
    return (
      Object.keys(o).length > 0 &&
      Object.values(o).filter((o) => o !== null && o !== undefined && o !== "")
        .length > 0
    );
  },

  isRequired(lang, languages) {
    if (languages === null || languages === undefined) {
      return false;
    }
    // console.log(lang, languages);
    return (
      languages.filter((o) => o.toLowerCase() === lang.toLowerCase()).length > 0
    );
  },
  nowFormatted() {
    let now = new Date();
    let day = now.getDate();
    let month = now.getMonth() + 1;
    if (day.toString().length === 1) day = "0" + day.toString();
    if (month.toString().length === 1) month = "0" + month.toString();
    return now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
  },
  createOdataHeaders(headers, transPrefix) {
    let odataHeaders = [];
    for (let header of headers) {
      let odataType = this.createOdataType({ header: header });

      let odataHeader = this.createOdataHeader(header, odataType, transPrefix);
      let subHeaders = [];
      if (header.subHeaders && header.subHeaders.length > 0) {
        subHeaders = headers
          .filter(
            (h) => header.subHeaders.filter((o) => o === h.text).length > 0,
          )
          .sort((a, b) => {
            const sortA = header.subHeaders.indexOf(a.text);
            const sortB = header.subHeaders.indexOf(b.text);
            if (sortA < sortB) {
              return -1;
            }
            if (sortA > sortB) {
              return 1;
            }
            return 0;
          });
      }
      if (subHeaders.length > 0) {
        odataHeader.subHeaders = [];
        for (const sh of subHeaders) {
          let t = this.createOdataType({ header: sh });
          odataHeader.subHeaders.push(
            this.createOdataHeader(sh, t, "globals." + header.text + "."),
          );
        }
      }

      odataHeaders.push(odataHeader);
      if (header.text === "SIN") {
        odataHeaders.push(
          new ODataHeader({
            title: transPrefix + "Temporary SIN",
            type: new ODataString("MemberIdentification/TemporarySIN"),
            sortable: header.sortable,
            visible: false,
            searchable: false,
            isIdentifier: false,
            allowVisibilityChange: false,
            alwaysInclude: true,
          }),
        );
      }
    }
    return odataHeaders;
  },
  createOdataType(options) {
    let key = options.header.value;
    let args = {};
    if (options.header.filterValue) {
      key = options.header.filterValue;
    }
    if (options.header.customSearchValue) {
      args.getWildcardFilter = (search) => {
        return options.header.customSearchValue.replace(
          "search-value",
          search.toLowerCase(),
        );
      };
    }
    if (options.header.expandValue) {
      args.getExpand = () => options.header.expandValue;
    }
    if (options.header.text === "FlagsTranslations") {
      args.getString = (item) => {
        return item.Flags.map((o) => {
          return translate2(o, "Name");
        }).join(", ");
      };
      args.getHtml = (item, type) => {
        return item.Flags.map(
          (p) =>
            "<span style='background-color:" +
            p.Color +
            ";padding:3px 6px;color:white;border-radius:3px;'>" +
            translate2(p, "Name") +
            "</span>",
        ).join(", ");
      };
      return new ODataString(key, args);
    } else if (options.header.text === "SIN") {
      return new ODataCustom(key, {
        getValue: (item) => {
          if (
            item.MemberIdentification.SIN !== null &&
            item.MemberIdentification.SIN !== undefined
          ) {
            return item.MemberIdentification.SIN;
          }
          if (
            item.MemberIdentification.TemporarySIN !== null &&
            item.MemberIdentification.TemporarySIN !== undefined
          ) {
            return item.MemberIdentification.TemporarySIN;
          }
          return null;
        },
        getString: (item, type) => {
          console.log(item, type);
          const v = type.getValue(item);
          console.log(v);
          return v === null ? "" : v.toString();
        },
        getWildcardFilter: (search) => {
          return `(contains(tolower(MemberIdentification/SIN), '${search
            .toLowerCase()
            .replaceAll("'", "''")}') or
          contains(tolower(MemberIdentification/TemporarySIN), '${search
            .toLowerCase()
            .replaceAll("'", "''")}'))`;
        },
        getFilter: (callback) => {
          const res = callback("wtf");
          if (res.indexOf("not contains") > -1) {
            const search = res.split(",")[1].slice(0, -2).substring(2);
            return `(not contains(tolower(MemberIdentification/SIN), '${search
              .toLowerCase()
              .replaceAll("'", "''")}') and
              not contains(tolower(MemberIdentification/TemporarySIN), '${search
                .toLowerCase()
                .replaceAll("'", "''")}'))`;
          } else if (res.indexOf("contains") > -1) {
            const search = res.split(",")[1].slice(0, -2).substring(2);
            return `(MemberIdentification/SIN ne null and (contains(tolower(MemberIdentification/SIN), '${search
              .toLowerCase()
              .replaceAll(
                "'",
                "''",
              )}')) or (MemberIdentification/TemporarySIN ne null) and 
              (contains(tolower(MemberIdentification/TemporarySIN), '${search
                .toLowerCase()
                .replaceAll("'", "''")}')))`;
          } /*else if (res.indexOf("eq") > -1) {
            const search = res
              .split("eq")[1]
              .slice(0, -1)
              .substring(2);
            return `((EligibilityRule/RuleType eq '${search}')) or ((Role eq '${search}')) or ((Email eq '${search}'))`;
          } else if (res.indexOf("ne") > -1) {
            const search = res
              .split("ne")[1]
              .slice(0, -1)
              .substring(2);
              return `((EligibilityRule/RuleType ne '${search}')) and ((Role ne '${search}')) and ((Email ne '${search}'))`;
          } else if (res.indexOf("startswith") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
            return `((startswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((startswith(tolower(Role), '${search}'))) or ((startswith(tolower(Email), '${search}')))`;
          } else if (res.indexOf("endswith") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
              return `((endswith(tolower(cast(EligibilityRule/RuleType, 'Edm.String')), '${search}'))) or ((endswith(tolower(Role), '${search}'))) or ((endswith(tolower(Email), '${search}')))`;
          }*/
          return undefined;
        },
        operators: [
          new ODataStringContains(),
          new ODataStringNotContains(),
          // new ODataStringEquals(),
          // new ODataStringNotEquals(),
          // new ODataStringStartsWith(),
          // new ODataStringEndsWith(),
        ],
      });
    } else if (options.header.type === "address") {
      args.getString = (item) => {
        let res = "";
        //console.log(item);
        if (
          item.CurrentContactInformation &&
          item.CurrentContactInformation.Address
        ) {
          //console.log("address:   -----------------------", item);
          if (item.CurrentContactInformation.Address.SuiteNumber) {
            res += item.CurrentContactInformation.Address.SuiteNumber;
          }
          if (item.CurrentContactInformation.Address.StreetNumber) {
            if (res.length > 0) {
              res += " ";
            }
            res +=
              item.CurrentContactInformation.Address.StreetNumber.toString();
          }
          if (item.CurrentContactInformation.Address.StreetName) {
            if (res.length > 0) {
              res += ", ";
            }
            res += item.CurrentContactInformation.Address.StreetName;
          }
          if (res.length > 0) {
            res += ", ";
          }
          if (item.CurrentContactInformation.Address.Country.IsOther) {
            res += item.CurrentContactInformation.Address.City;
            if (item.CurrentContactInformation.Address.OtherProvince) {
              res +=
                ", " + item.CurrentContactInformation.Address.OtherProvince;
            }
            if (item.CurrentContactInformation.Address.OtherPostalCode) {
              res +=
                " " + item.CurrentContactInformation.Address.OtherPostalCode;
            }
            res += " " + item.CurrentContactInformation.Address.OtherCountry;
          } else {
            res +=
              item.CurrentContactInformation.Address.City +
              ", " +
              item.CurrentContactInformation.Address.Province.Code;
            if (item.CurrentContactInformation.Address.PostalCode) {
              res += " " + item.CurrentContactInformation.Address.PostalCode;
            }
          }
        }
        return res;
      };
      args.getHtml = (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      };
      // key = "Address/City";
      return new ODataString(key, args);
    } else if (options.header.type === "age") {
      args.getString = (item) => {
        if (item[options.header.value] && options.date) {
          const [date, time] = options.date.split("T");
          const [year, month, day] = date.split("-");
          const [dobDate, dobTime] = item[options.header.value].split("T");
          const [dobYear, dobMonth, dobDay] = dobDate.split("-");
          return year - dobYear - (dobMonth > 1 ? 1 : 0);
        } else return "";
      };
      return new ODataString(key, args);
    } else if (options.header.type === "customcoverage") {
      // args.getString = (item) => {

      // };
      args.getHtml = (item, type) => {
        const customizedCoverages = item.CurrentActiveMemberBenefits.map(
          (cc) => {
            let str = translate2(cc.CurrentBenefit, "Name");
            if (cc.CoverageStatus) {
              str += ` - ${translate(
                cc.CoverageStatus,
                store.getters["common/language"].language,
              )}`;
              if (
                cc.CoverageStatus.Name == "Family" ||
                cc.CoverageStatus.Name == "Single Parent"
              ) {
                if (
                  cc.NoOfDependants !== null &&
                  cc.NoOfDependants !== undefined
                ) {
                  str += ` (${cc.NoOfDependants})`;
                }
              }
            }
            if (cc.Volume) {
              str += ` (${cc.Volume})`;
            }
            return str;
          },
        );
        return (
          "<div style='max-width: 200px'>" +
          customizedCoverages.join(",<br>") +
          "</div>"
        );
      };
      return new ODataString(key, args);
    } else if (
      options.header.type === "string" ||
      options.header.type === "select" ||
      options.header.type === "select-string" ||
      options.header.type === "select-trans2"
    ) {
      return new ODataString(key, args);
    } else if (options.header.type === "select-trans") {
      args.getString = (item) =>
        translate(
          item[options.header.value],
          store.getters["common/language"].language,
        );
      return new ODataString(key, args);
    } else if (options.header.type === "multiselect-trans") {
      args.getString = (item) =>
        item[options.header.value].map((o) =>
          translate(o, store.getters["common/language"].language),
        );
      args.getHtml = (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      };
      return new ODataString(key, args);
    } else if (options.header.type === "trans2") {
      const parts = options.header.value.split("/");
      let i = 0;
      // console.log(options.header);
      let translationsIndex = parts.indexOf("Translations[]");
      let k = parts[translationsIndex - 1];
      let translatableField = parts[translationsIndex + 1];
      //console.log("key is : --------------- ", k, translatableField);

      args.getString = (item) => {
        function getTranslation(parts, i, key, item, translatableField) {
          // if (key.indexOf("/") > -1 ) return "";
          // console.log(parts, i, key, JSON.stringify(item), item);
          if (i === parts.length || item === null) {
            return "";
          }
          if (parts[i] === key) {
            // console.log(key, item);
            if (item[key]) {
              if (item[key].Translations) {
                // console.log(
                //   "found translation ----- ",
                //   key,
                //   item,
                //   translatableField
                // );
                let translations = item[key].Translations.filter(
                  (o) =>
                    o.LanguageCode ===
                    store.getters["common/language"].language,
                );
                if (translations.length > 0) {
                  return translations[0][translatableField];
                } else {
                  return item[key][translatableField];
                }
              } else {
                //console.log("translations not found ----- ", key, item);
                return item[key].Name;
              }
            } else {
              //console.log(`item['${key}'] not found ----- `, key, item);
              return "";
            }
          } else {
            // console.log(JSON.stringify(item));
            if (parts[i].indexOf("[]") > -1) {
              //console.log("is Array: ", parts, i, key, item);
              if (item === null) {
                return "";
              }
              return item[parts[i].replace("[]", "")]
                .map((o) => {
                  //console.log(o);
                  return getTranslation(
                    parts,
                    i + 1,
                    key,
                    o,
                    translatableField,
                  );
                })
                .join(", ");
            } else {
              // console.log(parts[i]);
              if (item === null) {
                return "";
              }
              return getTranslation(
                parts,
                i + 1,
                key,
                item[parts[i].replace("[]", "")],
                translatableField,
              );
            }
          }
        }
        // console.log(key, item);
        if (parts[i].indexOf("[]") > -1) {
          // console.log("is Array2222: ", parts, i, key, item)
          return item[parts[i].replace("[]", "")]
            .map((o) => getTranslation(parts, i + 1, k, o, translatableField))
            .join(", ");
        } else {
          return getTranslation(parts, i, k, item, translatableField);
        }
      };
      args.getHtml = (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      };
      return new ODataString(key, args);
    } else if (options.header.type === "trans") {
      const parts = options.header.value.split("/");
      let i = 0;
      let translationsIndex = parts.indexOf("Translations[]");
      let k = parts[translationsIndex - 1];
      //console.log("key is : --------------- ", k);

      args.getString = (item) => {
        function getEnumTranslation(parts, i, key, item) {
          if (key.indexOf("/") > -1) return "";
          //console.log(parts, i, key, item, item[key]);
          if (i === parts.length || item === null) {
            return "";
          }
          if (parts[i] === key) {
            // console.log(key, item);
            if (item[key]) {
              if (item[key].Translations) {
                let translations = item[key].Translations.filter(
                  (o) =>
                    o.LanguageCode ===
                    store.getters["common/language"].language,
                );
                if (translations.length) {
                  return translations[0].DisplayValue;
                } else {
                  return item[key].Name;
                }
              } else {
                return item[key].Name;
              }
            } else {
              return "";
            }
          } else {
            return getEnumTranslation(parts, i + 1, key, item[parts[i]]);
          }
        }
        return getEnumTranslation(parts, i, k, item);
      };
      return new ODataString(key, args);
    } else if (options.header.type === "currency") {
      args.getString = (item) => {
        //console.log("currency found: ", item, options.header.value);
        let parts = options.header.value.split("/");
        let i = 0;
        function getString(parts, i, item) {
          if (item === null) {
            return "";
          }
          // console.log(parts.length, i, JSON.stringify(item));
          if (parts.length - 1 === i) {
            const value = item[parts[i]];
            if (typeof value !== "number") {
              return value;
            }

            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
            });
            return formatter.format(value);
          }
          // console.log(
          //   "asklaskdjasdjkashdjkashdjkashdjk",
          //   JSON.stringify(item[parts[i]])
          // );
          return getString(parts, i + 1, item[parts[i]]);
        }
        return getString(parts, i, item);
      };
      return new ODataDecimal(key, args);
    } else if (options.header.type === "date") {
      return new ODataDate(key, args);
    } else if (
      options.header.type === "multiselect" ||
      options.header.type === "multiselect-string"
    ) {
      args.getHtml = (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      };
      return new ODataString(key, args);
    } else if (options.header.type === "bool") {
      return new ODataBoolean(key, args);
    } else if (options.header.type === "int") {
      return new ODataInteger(key, args);
    } else if (options.header.type === "double") {
      return new ODataDecimal(key, args);
    } else if (options.header.type === "datetime") {
      return new ODataDateTime(key, args);
    } else if (options.header.type === "memberFiles") {
      args.getString = (item) => {
        const categories = item.MemberFiles.map((o) => o.FileCategory);
        const distinctCategories = [...new Set(categories)];
        return distinctCategories.join(", ");
      };
      args.getHtml = (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      };
      // console.log("gotcha!!!!");
      return new ODataString(key, args);
    } else {
      //console.log(options);
    }
  },
  createOdataHeader(header, odataType, titlePrefix) {
    if (header.type === "trans" || header.type === "trans2") {
      const parts = header.value.split("/");
      let orderby = parts[0];
      for (let i = 1; i < parts.indexOf("Translations[]"); i++) {
        orderby += "/" + parts[i];
      }
      return new ODataHeader({
        title: titlePrefix + header.text,
        type: odataType,
        sortable: header.sortable,
        visible: header.visible,
        searchable: header.searchable,
        isIdentifier: header.isId,
        allowVisibilityChange: header.allowVisibilityChange === true,
        alwaysInclude: header.alwaysInclude,
        version: 22,
        orderByKey: orderby + "/Name",
      });
    } else if (header.type === "age") {
      return new ODataHeader({
        title: titlePrefix + header.text,
        type: odataType,
        sortable: false, //header.sortable,
        visible: header.visible,
        searchable: false, //header.searchable,
        isIdentifier: header.isId,
        allowVisibilityChange: header.allowVisibilityChange === true,
        alwaysInclude: header.alwaysInclude,
        version: 8,
      });
    } else {
      return new ODataHeader({
        title: titlePrefix + header.text,
        type: odataType,
        sortable: header.sortable,
        visible: header.visible,
        searchable: header.searchable,
        isIdentifier: header.isId,
        allowVisibilityChange: header.allowVisibilityChange === true,
        alwaysInclude: header.alwaysInclude,
        version: 22,
      });
    }
  },
  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  },
  fillFormattedParams(item, params) {
    if (!item) return "";
    if (params?.length) {
      params.forEach((param) => {
        item = item.replace("{}", param);
      });
    }
    return item;
  },
};

const helpers = {
  install(Vue) {
    Vue.prototype.$helpers = helperMethods;
  },
};

export default helpers;
